import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { INgProductTour } from '@libs/frameworks/angular';

import { ResearchTourStepController } from './tour-steps-controllers/research-tour-steps.controller';
import { MASCOT_IMG_LINKS } from '../../../../../../assets';
import { EnumSidebarPage } from '../../../../../components/layout/sidebar/sidebar-pages.interface';
import { EnumResearchTourElement } from './research-tour.interface';


@Injectable({
	providedIn: 'root'
})
export class ProductTourResearch {

	//** Mascots */
	private readonly MASCOT_IMG_LINKS: typeof MASCOT_IMG_LINKS = MASCOT_IMG_LINKS;

	constructor(
		private router 					  : Router,
		private researchTourStepController: ResearchTourStepController
	) {}


	/**------------------------------------------------------
	 * Research Tour
	 */
	readonly PRODUCT_TOUR_RESEARCH: INgProductTour = {
		showTourProgressBullets	: true,
		showCloseButton			: true,
		hooks 		 			: {
			onStart 	 		: () => {},
			onClose 	 		: () => {},
			onComplete 	 		: () => this.router.navigateByUrl('/')
		},
		tourSteps 	 	: [
			{
				id				: EnumResearchTourElement.AppToggleBtn,
				pageUrl 		: '/',
				hint			: {
					title   	: `Let's do Research 🙏`,
					message 	: 'Up here you can click on the Flying Upload icon and it will take you to the upload section of the application.'
				}
			},
			{
				id				: EnumSidebarPage.ResearchMenuResearch,
				pageUrl 		: '/research/research/best-sellers',
				hint			: {
					title   	: 'Research',
					message 	: 'This is the Research section, where you can do all your merch by amazon research. It includes: Best Seller Search, Seller Trends, Live Research, and much more.'
				}
			},
			{
				id				: EnumSidebarPage.ResearchBestSeller,
				pageUrl 		: '/research/research/best-sellers',
				hint			: {
					title   	: 'Best Sellers',
					message 	: 'The Best Sellers page provides all the most popular and best selling designs of Merch By Amazon'
				}
			},
			{
				id				: EnumSidebarPage.ResearchMenuEvents,
				pageUrl 		: '/research/events/event-calendar?isProductTourLive=true',
				hint			: {
					title   	: 'Events',
					message 	: 'Check out the upcoming Events with all its selling designs in this section.'
				}
			},
			{
				id				: EnumSidebarPage.ResearchMenuTrademark,
				pageUrl 		: '/research/trademark/tm-search?search=nike&type=is',
				hint			: {
					title   	: 'Trademarks',
					message 	: 'This section is for all who want to be safe and secure. Check trademarks, see all new registration, and much more.'
				},
				hooks 			: {
					onStepLoad  : async (): Promise<void> => {
						await this.researchTourStepController.stepTmMenuOnStepLoad();
					},
					afterStep 	: async (): Promise<void> => {
						await this.researchTourStepController.stepTmMenuAfterStep();
					}
				}
			},
			{
				id				: EnumResearchTourElement.TmSearchAdvancedOptions,
				pageUrl 		: '/research/trademark/tm-search?search=nike&type=is',
				hint			: {
					title   	: 'TM Search',
					message 	: 'Most pages have advanced search options. Click on the "Advanced Options" link below the search button to opening the menu. Check out all these Advanced Options here for example.'
				},
				hooks 			: {
					onStepLoad  : async (): Promise<void> => {
						await this.researchTourStepController.stepTmSearchAdvancedOptionsOnStepLoad();
					},
					beforeStep 	: async (): Promise<void> => {
						await this.researchTourStepController.stepTmSearchAdvancedOptionsBeforeStep();
					}
				}
			},
			{
				id				: EnumSidebarPage.Tutorials,
				pageUrl 		: '/tutorials',
				hint			: {
					title   	: 'Tutorials',
					message 	: 'The tutorial section provides all necessary lessons for the tools and pages which we have in this application.'
				},
				hooks 			: {
					beforeStep 	: async (): Promise<void> => {
						await this.researchTourStepController.stepTutorialsMenuBeforeStep();
					}
				}
			},
			{
				id				: EnumResearchTourElement.DummyDomElement,
				pageUrl 		: '/tutorials',
				hint			: {
					title   	: 'Congratulations 🎉',
					message 	: 'You have successfully completed the Research Tour. Consider taking the Upload Tour as well.',
					image 		: this.MASCOT_IMG_LINKS.HAPPY
				}
			}
		]
	};
}
